module.exports = __webpack_public_path__ + "static/img/data2.79b4cd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/data2.jpg
// module id = wCsk
// module chunks = 13